module.exports = __webpack_public_path__ + "static/media/lancia.915d8c40.png";